import React, { useEffect, useState } from "react"
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from "@mui/material"
import { supplier_invoices_download } from "../../../services/expenses/expense"
import { purchase_order_pdf_get } from "../../../services/expenses/purchase_orders"

interface CustomTableProps {
  data: any;
}

const Order_or_Invoice: React.FC<CustomTableProps> = ({ data }) => {
  const [orderPdfBase64, setOrderPdfBase64] = useState("")
  const [invoicePdfBase64, setInvoicePdfBase64] = useState("")
  const [documentType, setDocumentType] = useState<"order" | "invoice">("order")
  const [orderError, setOrderError] = useState(false)
  const [invoiceError, setInvoiceError] = useState(false)

  useEffect(() => {
    const fetchOrderPdf = async () => {
      try {
        const orderRes = await purchase_order_pdf_get(data.id_order)
        if (orderRes.data.file) {
          setOrderPdfBase64(orderRes.data.file)
        } else {
          setOrderError(true)
        }
      } catch (err) {
        console.error("Error al obtener PDF de la orden:", err)
        setOrderError(true)
      }
    }

    const fetchInvoicePdf = async () => {
      if (data?.status_code == 1) {
        setInvoiceError(true)
        return
      }

      try {
        const invoiceRes = await supplier_invoices_download(
          data.details_invoice.relationships[0].id_invoice_fk,
          data.details_invoice.relationships[0].filename,
          "pdf"
        )
        if (invoiceRes.data.file) {
          setInvoicePdfBase64(invoiceRes.data.file)
        } else {
          setInvoiceError(true)
        }
      } catch (err) {
        console.error("Error al obtener PDF de la factura:", err)
        setInvoiceError(true)
      }
    }

    fetchOrderPdf()
    fetchInvoicePdf()
  }, [data])

  const selectedPdf = documentType === "order" ? orderPdfBase64 : invoicePdfBase64
  const isError = documentType === "order" ? orderError : invoiceError

  return (
    <Box sx={{ bgcolor: "#f5f5f5", p: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel id="select-document-label">Tipo de documento</InputLabel>
          <Select
            labelId="select-document-label"
            value={documentType}
            label="Tipo de documento"
            onChange={(e) => setDocumentType(e.target.value as "order" | "invoice")}
          >
            <MenuItem value="order">Orden de Compra</MenuItem>
            <MenuItem value="invoice">Factura</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ bgcolor: "#2d3748", p: 2, borderRadius: 1 }}>
        <Box
          sx={{
            bgcolor: "white",
            height: 500,
            borderRadius: 1,
            overflow: "hidden",
          }}
        >
          {isError ? (
            <Typography p={2}><strong>No se descargó el documento</strong></Typography>
          ) : selectedPdf ? (
            <iframe
              title="PDF Viewer"
              src={`data:application/pdf;base64,${selectedPdf}`}
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          ) : (
            <Typography p={2}>Cargando PDF...</Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default Order_or_Invoice
